<div class="p-fluid grid" [formGroup]="stepElementForm.controls.settings">
    <div class="col-12">
        <label for="takePhotoButtonId-{{uniqueId}}" class="pb-2">{{'elements.shareButton.takePhotoButtonId'|translate|firstUpper}}<app-tooltip value="{{'elements.tooltip.shareButton.takePhotoButtonId'|translate|firstUpper}}"></app-tooltip></label>
        <p-dropdown placeholder="{{'elements.shareButton.takePhotoButtonIdPlaceholder'|translate|firstUpper}}" id="takePhotoButtonId-{{uniqueId}}" [showClear]="true"
                    [options]="availableTakePhotoButtonIds" (onChange)="takePhotoButtonChanged($event)" appendTo="body"></p-dropdown>
    </div>
</div>
